// @ai-generated 2026-07-21T03:45:01+00:00 by philipp.kammerer@synqony.com using claude-fable-5
import { useMessagesRepository } from '@Hooks/useRepository';
import { type ApiUpsertNotificationSettingRequest } from '@Model';
import { NotificationSettingsRepository } from '@Repositories/Messages';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export function useUpsertNotificationSetting() {
    const settings = useMessagesRepository(NotificationSettingsRepository);
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (request: ApiUpsertNotificationSettingRequest) => settings.upsert(request),
        onSuccess: () => {
            void queryClient.invalidateQueries({ queryKey: ['notificationSettings'] });
            // Muting a type changes which notifications are visible (list and unread count are
            // filtered server-side), so those caches are stale after every settings change.
            void queryClient.invalidateQueries({ queryKey: ['notifications'] });
        },
    });
}
